import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const baseURL = process.env.REACT_APP_API_BASE_URL;

export const getGestaoUserRole = () => {
  const token = localStorage.getItem('jwtToken');
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    const roleValue =
      decoded?.role ||
      decoded?.Role ||
      decoded?.papel ||
      decoded?.perfil ||
      decoded?.permissao;

    if (typeof roleValue === 'string') {
      return roleValue.toLowerCase();
    }

    return null;
  } catch (error) {
    console.error('Erro ao decodificar role do JWT:', error);
    return null;
  }
};

export const getCorretores = async (idCliente) => {
  const token = localStorage.getItem('jwtToken');
  
  const response = await axios.get(
    `${baseURL}/produto/AV/corretores`,
    {
      params: { idCliente },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );
  
  return response.data;
};

export const getGerentes = async (idCliente) => {
  const token = localStorage.getItem('jwtToken');
  
  const response = await axios.get(
    `${baseURL}/produto/AV/gerentes`,
    {
      params: { idCliente },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );
  
  return response.data;
};

export const getCorretoresCv = async (idCliente) => {
  const token = localStorage.getItem('jwtToken');
  
  const response = await axios.get(
    `${baseURL}/produto/AV/corretores-cv`,
    {
      params: { idCliente },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );
  
  return response.data;
};

export const createCorretor = async ({ idCliente, idImobiliaria, idCorretor }) => {
  const token = localStorage.getItem('jwtToken');

  const response = await axios.post(
    `${baseURL}/produto/AV/corretores`,
    {
      idImobiliaria,
      idCorretor,
    },
    {
      params: { idCliente },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );

  return response.data;
};

export const updateCorretor = async ({
  idCliente,
  idCorretor,
  novoNome,
  novoTelefone,
  novoCelular,
}) => {
  const token = localStorage.getItem('jwtToken');

  const response = await axios.put(
    `${baseURL}/produto/AV/corretores`,
    {
      idCorretor,
      novoNome,
      novoTelefone,
      novoCelular,
    },
    {
      params: { idCliente },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );

  return response.data;
};

export const createGerente = async ({
  idCliente,
  idImobiliaria,
  nome,
  celular,
}) => {
  const token = localStorage.getItem('jwtToken');

  const response = await axios.post(
    `${baseURL}/produto/AV/gerentes`,
    {
      idImobiliaria,
      nome,
      celular,
    },
    {
      params: { idCliente },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );

  return response.data;
};

export const deleteCorretor = async ({ idCliente, idCorretor, telefone }) => {
  const token = localStorage.getItem('jwtToken');

  const response = await axios.delete(
    `${baseURL}/produto/AV/corretores`,
    {
      params: { idCliente },
      data: {
        idCorretor,
        telefone,
      },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );

  return response.data;
};

export const createCorretorJustificativa = async ({
  idClienteAipim,
  idUsuario,
  valorAnterior,
  valorNovo,
  justificativa,
}) => {
  const token = localStorage.getItem('jwtToken');

  const payload = {
    idClienteAipim,
    idUsuario,
    idProduto: 1,
    campo: 'Corretor',
    valorNovo: valorNovo ?? '',
    valorAnterior: valorAnterior ?? '',
    justificativa,
  };

  const response = await axios.post(
    `${baseURL}/produto/Justificativa`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
    },
  );

  return response.data;
};

export const updateGerente = async ({
  idCliente,
  celularAtual,
  novoCelular,
  novoNome,
}) => {
  const token = localStorage.getItem('jwtToken');

  const response = await axios.put(
    `${baseURL}/produto/AV/gerentes`,
    {
      celularAtual,
      novoCelular,
      novoNome,
    },
    {
      params: { idCliente },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );

  return response.data;
};

export const deleteGerente = async ({ idCliente, idImobiliaria, celular }) => {
  const token = localStorage.getItem('jwtToken');

  const response = await axios.delete(
    `${baseURL}/produto/AV/gerentes`,
    {
      params: { idCliente },
      data: {
        idImobiliaria,
        celular,
      },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );

  return response.data;
};

export const createGerenteJustificativa = async ({
  idClienteAipim,
  idUsuario,
  valorAnterior,
  valorNovo,
  justificativa,
}) => {
  const token = localStorage.getItem('jwtToken');

  const payload = {
    idClienteAipim,
    idUsuario,
    idProduto: 1,
    campo: 'Gerente',
    valorNovo: valorNovo ?? '',
    valorAnterior: valorAnterior ?? '',
    justificativa,
  };

  const response = await axios.post(
    `${baseURL}/produto/Justificativa`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
    },
  );

  return response.data;
};

export const getGerenteJustificativas = async ({ idClienteAipim }) => {
  const token = localStorage.getItem('jwtToken');

  const response = await axios.get(
    `${baseURL}/produto/Justificativa/historico`,
    {
      params: {
        idClienteAipim,
        idProduto: 1,
        campo: 'Gerente',
      },
      headers: { Authorization: token ? `Bearer ${token}` : '' },
    },
  );

  return response.data;
};

export const getImobiliarias = async (idCliente) => {
  const token = localStorage.getItem('jwtToken');
  
  const response = await axios.get(
    `${baseURL}/produto/AV/imobiliarias`,
    {
      params: { idCliente },
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    }
  );
  
  return response.data;
};
